import React, {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useMemo,
  useRef,
} from "react";
import { Form, message } from "antd";
import BaseModal from "components/BaseModal";
import {
  FieldTypes,
  generateFormFields,
  nameRegexValidator,
  urlRegexValidator,
} from "utils/formUtils";
import _ from "lodash";
// import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
// import ModalUtil from "utils/modalUtil";
import { MODAL_SIZE_MEDIUM } from "constants/Layout";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import ModalUtil from "utils/modalUtil";
import LeanIXMappingForm from "./LeanIXMappingForm";
import { duplicateNameValidator } from "utils/validatorUtil";
import { useFeatureFlag } from "contexts/FeatureFlagContext";

function LeanIXConfigForm(
  { name, displayName, loginConfigList, noMappingForm, ...props },
  ref
) {
  const isEdit = !_.isUndefined(props.config);
  const [form] = Form.useForm();
  const thisRef = useRef();
  const featureFlags = useFeatureFlag();  

  useImperativeHandle(ref, () => ({
    ...thisRef,
  }));

  const onOk = useCallback(async () => {
    await form.validateFields();
    try {
      const toolName = name.toUpperCase().replace(" ", "_");
      let payload = { ...form.getFieldsValue(), ticketSystemType: "LEAN_IX" };

      const configUrl = !isEdit
        ? "postTicketSystemToolLoginDetails"
        : "updateTicketSystemToolLoginDetails";

      const response =
        await ToolsIntegrationsAPI[configUrl](
          toolName,
          payload,
          props.config?.id
        ).promise;
      message.success(`${displayName} Login Configuration created`);
      message.success("Syncing assets, it may take some time.");
      //trigger auto sync for projects when new login config is added
      await ToolsIntegrationsAPI.syncAsset("LEAN_IX").promise;
      if (!isEdit && !noMappingForm) {
        ModalUtil.show({
          content: (
            <LeanIXMappingForm
              onUpdateConfigComponent={props.onUpdateConfigComponent}
              name={name}
              loginConfigId={response.id}
              displayName={displayName}
            />
          ),
        });
      }
      props.onUpdateConfigComponent && props.onUpdateConfigComponent(response);
    } catch (err) {
      console.log(err);
      if (!_.isEmpty(err.response.data.errors)) {
        const { field, defaultMessage } = err.response?.data?.errors[0];
        form.setFields([
          {
            name: field,
            errors: [defaultMessage],
          },
        ]);
      }
      return Promise.reject(err.response?.data?.message);
    }
  }, [form, name, isEdit, props, displayName, noMappingForm]);

  const modalProps = {
    title: (
      <>
        {isEdit ? "Edit" : "Add"} {displayName} Login Credentials{" "}
      </>
    ),
    width: MODAL_SIZE_MEDIUM,
    onOk: onOk,
  };

  const fields = useMemo(
    () => [
      {
        name: "name",
        label: "Name",
        colSpan: 12,
        required: true,
        props: {
          autoFocus: true,
        },
        rules: [
          duplicateNameValidator({ list: loginConfigList }),
          nameRegexValidator,
        ],
      },
      {
        name: "url",
        label: "URL",
        colSpan: 12,
        required: true,
        rules: [urlRegexValidator()],
      },
      {
        name: "apiToken",
        label: "API Token",
        type: FieldTypes.PASSWORD,
        colSpan: 12,
        required: true,
      },
      ...(featureFlags.ENABLE_LEANIX_V4_SUPPORT ? [{
        name: "metaModel",
        label: "Meta Model",
        disabled: true,
        colSpan: 12,
      }] : [])
    ],
    [featureFlags.ENABLE_LEANIX_V4_SUPPORT, loginConfigList]
  );

  return (
    <BaseModal
      modalProps={modalProps}
      ref={thisRef}
      afterClose={props.afterClose}
    >
      <Form initialValues={{ metaModel: "v4", ...props.config }} form={form} layout="vertical">
        {generateFormFields(fields)}
      </Form>
    </BaseModal>
  );
}

export default forwardRef(LeanIXConfigForm);
